// ========= START: src/utils/audioManager.js (COMPLETE REPLACEMENT) =========
class AudioManager {
  constructor() {
    this.audioContext = null;
    this.sounds = {};
    this.currentBgmKey = null;
    this.bgmVolume = 0.1;
    this.sfxVolume = 0.8;
    this.isMuted = true;
    this.isUnlocked = false; // NEW: Audio unlock gate

    this.soundFiles = {
      chatBgmMenu: '/assets/audio/chat_bgm_menu.mp3',
      gameBgmMenu: '/assets/audio/game_bgm_menu.mp3',
      bgmPlay: '/assets/audio/bgm_play.mp3',
      sfxClick: '/assets/audio/sfx_click.mp3',
      sfxCorrect: '/assets/audio/sfx_correct.mp3',
      sfxLevelUp: '/assets/audio/sfx_level_up.mp3',
      sfxWallBreak: '/assets/gameplay/wall_break.mp3',
      sfxWallBounce: '/assets/gameplay/wall_bounce.mp3',
    };

    for (const key in this.soundFiles) {
      const audio = new Audio(`${process.env.PUBLIC_URL}${this.soundFiles[key]}`);
      if (key.startsWith('bgm')) {
        audio.loop = true;
      }
      this.sounds[key] = audio;
    }
  }

  // NEW: Method to unlock audio on first user interaction
  unlockAudio() {
    if (this.isUnlocked) return;
    this.isUnlocked = true;
    // Attempt to play the BGM that was requested before the unlock
    if (this.currentBgmKey && this.sounds[this.currentBgmKey]) {
      const bgm = this.sounds[this.currentBgmKey];
      bgm.volume = this.isMuted ? 0 : this.bgmVolume;
      bgm.play().catch(error => console.warn(`Initial BGM play was interrupted:`, error));
    }
  }

  toggleMute() {
    this.isMuted = !this.isMuted;
    if (this.currentBgmKey && this.sounds[this.currentBgmKey]) {
      this.sounds[this.currentBgmKey].volume = this.isMuted ? 0 : this.bgmVolume;
    }
    return this.isMuted;
  }

  playBGM(key) {
    if (this.currentBgmKey === key && !this.sounds[key].paused) {
      return;
    }
    this.stopBGM();

    const bgm = this.sounds[key];
    if (bgm) {
      this.currentBgmKey = key; // Set the key regardless of unlocked state
      bgm.volume = this.isMuted ? 0 : this.bgmVolume;

      // MODIFICATION: Only try to play if audio is unlocked
      if (this.isUnlocked) {
        bgm.play().catch(error => console.error(`Error playing BGM "${key}":`, error));
      }
    }
  }

  stopBGM() {
    if (this.currentBgmKey && this.sounds[this.currentBgmKey]) {
      const currentBgm = this.sounds[this.currentBgmKey];
      currentBgm.pause();
      currentBgm.currentTime = 0;
    }
    this.currentBgmKey = null;
  }

  playSFX(key) {
    // MODIFICATION: Do not play if not unlocked or is muted
    if (!this.isUnlocked || this.isMuted) return;

    const sfx = this.sounds[key];
    if (sfx) {
      sfx.currentTime = 0;
      sfx.volume = this.sfxVolume;
      sfx.play().catch(error => console.error(`Error playing SFX "${key}":`, error));
    }
  }

  playWordAudio(src) {
    if (!this.isUnlocked || this.isMuted) return;
    const wordAudio = new Audio(src);
    wordAudio.volume = this.sfxVolume;
    wordAudio.play().catch(error => console.error('Error playing word audio:', error));
  }

  setBgmVolume(volume) {
    this.bgmVolume = volume;
    if (this.currentBgmKey && this.sounds[this.currentBgmKey] && !this.isMuted) {
      this.sounds[this.currentBgmKey].volume = this.bgmVolume;
    }
  }

  setSfxVolume(volume) {
    this.sfxVolume = volume;
  }
}

const audioManager = new AudioManager();
export default audioManager;
// ========= END: src/utils/audioManager.js (COMPLETE REPLACEMENT) =========